import { createSlice } from '@reduxjs/toolkit';

const userProfile = createSlice({
  name: 'userProfile',
  initialState: {
    userPrivilege: {},
  },

  reducers: {
    resetUserProfile: (state) => {
      state.userPrivilege = {};
    },

    requestUser: (state, action) => {
      state.userPrivilege = {}
    },

    receiveUserPrivilege: (state, action) => {
      state.userPrivilege = {
        ...action.payload.user_privilege,
      };
    },

    updateUserPrivilege: (state, action) => {
      state.userPrivilege= {
        ...state.userPrivilege,
        is_admin: action.payload.user_privilege.is_admin,
        position: action.payload.user_privilege.position,
        badge_id: action.payload.user_privilege.badge_id,
        status: action.payload.user_privilege.status,
      }
    },

    updateUser: (state, action) => {
      const result = {
        ...state.userPrivilege,
        first_name: action.payload.first_name,
        last_name: action.payload.last_name,
        email: action.payload.email,
        unconfirmed_email: action.payload.unconfirmed_email,
        user: action.payload,
      };

      if( action.payload.phone_number !== undefined ) {
        result.phone_number = action.payload.phone_number;
      //Hack to get phone number from recent user priv since phone_number is not returned in the update user API
      }else if ( action.payload.recent_user_privilege !== undefined && action.payload.recent_user_privilege.phone_number !== undefined ) {
        result.phone_number = action.payload.recent_user_privilege.phone_number;
      }

      if ( action.payload.recent_user_privilege !== undefined && action.payload.recent_user_privilege.profile_image_thumb_url !== undefined ) {
        result.profile_image_thumb_url = action.payload.recent_user_privilege.profile_image_thumb_url;
      }

      state.userPrivilege = result
    },

    removeChannelFromUser: (state, action) => {
      const channels = state.userPrivilege.channel_ids.filter((channel_id) => channel_id !== action.payload.channel_id);
      state.userPrivilege = {
        ...state.userPrivilege,
        channel_ids: channels,
      }
    },

    addChannelToUser: (state, action) => {
      const channels = state.userPrivilege.channel_ids.concat(action.payload.channel_id);
      state.userPrivilege = {
        ...state.userPrivilege,
        channel_ids: channels,
      }
    },

  },
});

export default userProfile;
